import React, { useEffect, useState } from "react";
import axios from "axios";

const OrderCardImage = (props) => {
  const { item } = props;
  const [imageUrl, setImageUrl] = useState(null);
  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await axios.get(
          `http://127.0.0.1:8000/api/v1/admin/files/${item?.product?.image_id}`,
          {
            responseType: "blob",
          },
        );
        const url = URL.createObjectURL(response.data);
        setImageUrl(url);
      } catch (err) {
        console.error("خطا در دریافت تصویر:", err);
      }
    };

    fetchImage();
  }, [item?.product?.image_id]);

  if (!imageUrl) return <p>در حال بارگذاری تصویر...</p>;

  return (
    <div
      className="min-w-[100px] h-[100px] relative rounded-md overflow-hidden"
      key={item.image_id}
    >
      <img
        src={imageUrl}
        alt="product buying"
        className="object-cover w-full h-full"
      />
    </div>
  );
};

export default OrderCardImage;
